import { VIEWPORT_TOOLSET_IDS } from "@/viewport-tools/core/contracts";
import {
  type ScaleToolsetRailController,
  type ViewportToolsetRailController,
  type ViewportToolsetRailPlugin,
} from "@/viewport-tools/rail/types";
import { renderScaleToolsetRail } from "@/viewport-tools/scale/rail-renderer";

function isScaleToolsetRailController(
  controller: ViewportToolsetRailController
): controller is ScaleToolsetRailController {
  return controller.toolsetId === VIEWPORT_TOOLSET_IDS.scale;
}

export const SCALE_TOOLSET_RAIL_PLUGIN: ViewportToolsetRailPlugin<ScaleToolsetRailController> =
  {
    id: VIEWPORT_TOOLSET_IDS.scale,
    isController: isScaleToolsetRailController,
    render: renderScaleToolsetRail,
  };
